import { createSelector } from "@ngrx/store";
import { AppState } from "./app.state";

export const getAttendanceFeatureState = (state: AppState) => state.attendanceState;

// app state
export const companySelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.company
);

export const userSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.user
);

// attendance
export const isLoadingSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.isLoading
);

export const pinnedAttendancesSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.pinnedAttendances
);

export const attendancesSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.attendances
);

export const attendanceSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.attendance
);

export const notesSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.notes
);

export const messagesSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.messages
);

// Live conversation-message count that drives the copilot "minimum messages" gate.
// Backed by a dedicated state field (set on load, bumped on each real-time message)
// so it stays reactive without ever touching the message list.
export const copilotGateMessageCountSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.copilotGateMessageCount ?? 0
);

export const pagerParamsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.pagerParams
);

export const errorSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.error
);

export const openCloseSidebarRightSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.sidebarRight
);

export const integrationsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.integrations
);

export const settingsModulesSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.settingsModules
);

export const openClosecontactInfoSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.contactInfo
)

export const tagsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.tags
)

export const countsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.counts
)

export const messageHitsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.messageHits
)

export const focusMessageSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.focusMessage
)

export const whispersSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.whispers
)

export const whisperPendingSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.whisperPendingAttendanceIds
)

// Tab counters shown to the agent: contact-field matches (counts) plus the attendances found
// only through a message, per status.
export const countsWithMessagesSelector = createSelector(
  getAttendanceFeatureState,
  (state) => {
    const extra = state.messageHits.messageOnlyCounts;
    if (!extra?.length) return state.counts;
    const statuses = Array.from(new Set([...state.counts.map((c) => c.status), ...extra.map((e) => e.status)]));
    return statuses.map((status) => {
      const fromCounts = state.counts.find((c) => c.status === status);
      const fromMessages = extra.find((e) => e.status === status);
      return {
        status,
        count: (fromCounts?.count ?? 0) + (fromMessages?.count ?? 0),
        unread: (fromCounts?.unread ?? 0) + (fromMessages?.unread ?? 0),
      };
    });
  }
)

export const hasPipedriveIntegrationSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.hasPipedriveIntegration
)

export const simpleChannelsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.simpleChannels
)

export const simpleDepartmentsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.simpleDepartments
)

export const simpleTagsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.simpleTags
)

export const simpleUsersSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.simpleUsers
)

export const simpleTabulationsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.simpleTabulations
)

export const simpleLeadSourcesSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.simpleLeadSources
)

export const simpleSalesMonitorsSelector = createSelector(
  getAttendanceFeatureState,
  (state) => state.simpleSalesMonitors
);
